/**
 * Diminova — Agregar al carrito → header cart fly
 * Quantity +/- removed. Always adds 1 unit.
 * ATC click → flash + particle flies to HEADER cart + real Shopify count
 * ~5s later (or when drawer closes) → cart button bounce “aquí estoy”
 */
(function () {
  'use strict';

  // Shared across duplicate script loads (Shopify can inject the asset twice)
  const S = (window.__diminovaCartTemptState = window.__diminovaCartTemptState || {
    celebrating: false,
    lastSyncedCount: null,
    temptTimer: null,
    temptPending: false,
    temptReadyAt: 0,
    temptPlaying: false,
  });

  function getCartIcon() {
    return document.querySelector('cart-icon.header-actions__cart-icon, .header-actions__cart-icon');
  }

  function isCartDrawerOpen() {
    const drawer = document.querySelector('cart-drawer-component, cart-drawer, .cart-drawer');
    if (drawer) {
      if (drawer.hasAttribute('open')) return true;
      if (drawer.getAttribute('aria-hidden') === 'false' && drawer.matches('dialog, [role="dialog"]')) {
        return true;
      }
    }
    return !!document.querySelector(
      'button[aria-controls*="cart"][aria-expanded="true"], .header-actions__cart-icon[aria-expanded="true"]'
    );
  }

  function getCartActionButton(cartIcon) {
    return (
      cartIcon?.closest('button.header-actions__action, .header-actions__action, a.header-actions__action') ||
      cartIcon?.closest('button, a') ||
      cartIcon?.parentElement
    );
  }

  function swayCartButton(btn) {
    if (!btn || typeof btn.animate !== 'function') return null;
    try {
      btn.getAnimations?.().forEach((a) => a.cancel());
    } catch (_) {}

    // Soft side-to-side “aquí estoy” — gentle for shoppers
    return btn.animate(
      [
        {
          transform: 'translate3d(0, 0, 0) rotate(0deg)',
          borderColor: 'rgba(0, 212, 255, 0.4)',
          boxShadow: '0 0 12px rgba(0, 212, 255, 0.18)',
          offset: 0,
        },
        {
          transform: 'translate3d(-5px, 0, 0) rotate(-3deg)',
          borderColor: 'rgba(0, 212, 255, 0.75)',
          boxShadow: '0 0 16px rgba(0, 212, 255, 0.35)',
          offset: 0.25,
        },
        {
          transform: 'translate3d(5px, 0, 0) rotate(3deg)',
          borderColor: 'rgba(255, 79, 216, 0.7)',
          boxShadow: '0 0 16px rgba(255, 79, 216, 0.3)',
          offset: 0.55,
        },
        {
          transform: 'translate3d(-3px, 0, 0) rotate(-2deg)',
          borderColor: 'rgba(0, 212, 255, 0.65)',
          boxShadow: '0 0 14px rgba(0, 212, 255, 0.28)',
          offset: 0.8,
        },
        {
          transform: 'translate3d(0, 0, 0) rotate(0deg)',
          borderColor: 'rgba(0, 212, 255, 0.4)',
          boxShadow: '0 0 12px rgba(0, 212, 255, 0.18)',
          offset: 1,
        },
      ],
      {
        duration: 1600,
        easing: 'ease-in-out',
        iterations: 1,
        fill: 'none',
        composite: 'replace',
      }
    );
  }

  function tintCartIcon(cartIcon) {
    if (!cartIcon || typeof cartIcon.animate !== 'function') return;
    try {
      cartIcon.getAnimations?.().forEach((a) => a.cancel());
    } catch (_) {}
    cartIcon.animate(
      [
        { color: '#00d4ff', filter: 'drop-shadow(0 0 5px rgba(0,212,255,0.35))' },
        { color: '#7cf0ff', filter: 'drop-shadow(0 0 10px rgba(0,212,255,0.55))' },
        { color: '#ff7ae8', filter: 'drop-shadow(0 0 10px rgba(255,79,216,0.5))' },
        { color: '#00d4ff', filter: 'drop-shadow(0 0 5px rgba(0,212,255,0.35))' },
      ],
      { duration: 1600, easing: 'ease-in-out', iterations: 1 }
    );
  }

  function stopCartTemptation() {
    clearTimeout(S.temptTimer);
    S.temptPending = false;
    S.temptPlaying = false;
    S.temptReadyAt = 0;

    const icon = getCartIcon();
    const btn = getCartActionButton(icon);
    icon?.classList.remove('diminova-cart-tempt');
    btn?.classList.remove('diminova-cart-tempt-btn');
    try {
      icon?.getAnimations?.().forEach((a) => a.cancel());
      btn?.getAnimations?.().forEach((a) => a.cancel());
    } catch (_) {}
  }

  function isGoingToCheckout(el) {
    if (!el) return false;
    const link = el.closest('a[href*="/checkout"], a[href*="checkout"], button[name="checkout"], [name="checkout"]');
    if (link) return true;
    const form = el.closest('form[action*="/checkout"], form[action*="checkout"]');
    return !!form;
  }

  function getLiveCartCount() {
    const bubble = document.querySelector(
      '.header-actions__cart-icon .cart-bubble__text-count, .header-actions__cart-icon [ref="cartBubbleCount"]'
    );
    const fromBubble = Number(bubble?.textContent || 0);
    return Math.max(S.lastSyncedCount ?? 0, fromBubble || 0);
  }

  function playCartTemptation() {
    if (S.temptPlaying) return;
    S.temptPlaying = true;
    S.temptPending = false;
    let emptyRetries = 0;

    const runWave = () => {
      // Keep nudging until checkout — pause while drawer covers the icon
      if (isCartDrawerOpen()) {
        S.temptTimer = setTimeout(runWave, 700);
        return;
      }

      const liveCount = getLiveCartCount();
      if (liveCount <= 0) {
        emptyRetries += 1;
        if (emptyRetries > 12) {
          stopCartTemptation();
          return;
        }
        S.temptTimer = setTimeout(runWave, 500);
        return;
      }
      emptyRetries = 0;
      S.lastSyncedCount = liveCount;

      const cartIcon = getCartIcon();
      const btn = getCartActionButton(cartIcon);
      if (!cartIcon || !btn) {
        S.temptTimer = setTimeout(runWave, 400);
        return;
      }

      cartIcon.classList.add('diminova-cart-tempt');
      btn.classList.add('diminova-cart-tempt-btn');

      swayCartButton(btn);
      tintCartIcon(cartIcon);

      // Soft loop: sway, rest, sway… until checkout
      S.temptTimer = setTimeout(runWave, 2800);
    };

    runWave();
  }

  function tickTemptation() {
    clearTimeout(S.temptTimer);
    if (!S.temptPending || S.temptPlaying) return;

    const remaining = S.temptReadyAt - Date.now();
    if (remaining > 0) {
      S.temptTimer = setTimeout(tickTemptation, Math.min(remaining, 400));
      return;
    }

    if (isCartDrawerOpen()) {
      S.temptTimer = setTimeout(tickTemptation, 400);
      return;
    }

    if (!getCartIcon()) {
      S.temptTimer = setTimeout(tickTemptation, 300);
      return;
    }

    playCartTemptation();
  }

  function scheduleCartTemptation() {
    // Always (re)arm from any add, including first unit (qty 1)
    S.temptPending = true;
    S.temptReadyAt = Date.now() + 5000;
    // If already looping, keep looping; just refresh readiness for future stops/restarts
    if (!S.temptPlaying) tickTemptation();
  }

  function onDrawerMaybeClosed() {
    if (S.temptPlaying) return;
    if (!S.temptPending) return;
    if (Date.now() < S.temptReadyAt) return;
    if (isCartDrawerOpen()) return;
    tickTemptation();
  }

  function getProductForm() {
    return document.querySelector(
      '.product-details product-form-component, product-form-component[data-product-id]'
    );
  }

  function ensurePurchaseLayout(form) {
    const buttons = form.querySelector('.product-form-buttons');
    if (!buttons) return;

    buttons.classList.add('diminova-purchase');

    const qtyWrap = buttons.querySelector('.quantity-selector-wrapper');
    if (qtyWrap) qtyWrap.classList.add('diminova-purchase__hidden');

    const atc =
      buttons.querySelector('add-to-cart-component') ||
      buttons.querySelector('.add-to-cart-button')?.closest('span') ||
      buttons.querySelector('span:has(.add-to-cart-button)');
    if (atc && atc.parentElement === buttons) {
      atc.classList.add('diminova-purchase__buy');
      buttons.appendChild(atc);
    }

    const accel = buttons.querySelector('.accelerated-checkout-block, accelerated-checkout-block');
    if (accel) accel.classList.add('diminova-purchase__hidden');

    const label = buttons.querySelector(
      '.add-to-cart-text__content span span, .add-to-cart-text__content'
    );
    if (label) {
      const textNode = label.querySelector('span span') || label.querySelector('span') || label;
      if (textNode && /comprar ahora/i.test(textNode.textContent || '')) {
        textNode.textContent = 'Agregar al carrito';
      }
    }

    let qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';
      form.querySelector('form')?.appendChild(qtyInput) || form.appendChild(qtyInput);
    } else {
      qtyInput.value = '1';
    }
  }

  async function fetchCartCount() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return null;
      const cart = await res.json();
      return typeof cart.item_count === 'number' ? cart.item_count : null;
    } catch (_) {
      return null;
    }
  }

  function setHeaderCartCount(totalCount, { animate } = { animate: true }) {
    const cartIcon = getCartIcon();
    if (!cartIcon) return;

    const n = Math.max(0, Number(totalCount) || 0);
    S.lastSyncedCount = n;

    if (typeof cartIcon.renderCartBubble === 'function') {
      cartIcon.renderCartBubble(n, !!animate && n > 0);
    } else {
      const bubbleCount = cartIcon.querySelector('.cart-bubble__text-count, [ref="cartBubbleCount"]');
      const bubble = cartIcon.querySelector('.cart-bubble, [ref="cartBubble"]');
      if (bubbleCount) {
        bubbleCount.textContent = n < 100 ? String(n) : '';
        bubbleCount.classList.toggle('hidden', n === 0);
      }
      if (bubble) bubble.classList.toggle('visually-hidden', n === 0);
      cartIcon.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
    }

    if (animate) {
      cartIcon.classList.remove('diminova-cart-pop');
      void cartIcon.offsetWidth;
      cartIcon.classList.add('diminova-cart-pop');
      if (n > 0) scheduleCartTemptation();
    }
  }

  function flyToHeaderCart(fromEl) {
    const cartIcon = getCartIcon();
    if (!fromEl || !cartIcon) return;

    const from = fromEl.getBoundingClientRect();
    const to = cartIcon.getBoundingClientRect();
    if (!from.width || !to.width) return;

    const particle = document.createElement('div');
    particle.className = 'diminova-fly-particle';
    particle.innerHTML =
      '<span class="diminova-fly-particle__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M6 7h15l-1.5 9h-12z"/><path d="M6 7L5 3H2"/>' +
      '<circle cx="9" cy="20" r="1.25"/><circle cx="18" cy="20" r="1.25"/>' +
      '</svg></span>' +
      '<span class="diminova-fly-particle__count">+1</span>';

    const startX = from.left + from.width / 2;
    const startY = from.top + from.height / 2;
    const endX = to.left + to.width / 2;
    const endY = to.top + to.height / 2;

    particle.style.left = startX + 'px';
    particle.style.top = startY + 'px';
    document.body.appendChild(particle);

    requestAnimationFrame(() => {
      particle.style.setProperty('--fly-x', endX - startX + 'px');
      particle.style.setProperty('--fly-y', endY - startY + 'px');
      particle.classList.add('is-flying');
    });

    setTimeout(() => particle.remove(), 560);
  }

  function celebrateAddToCart(form) {
    // Arm temptation immediately on first add (qty 1+)
    scheduleCartTemptation();

    if (S.celebrating) return;
    S.celebrating = true;

    const buyBtn =
      form.querySelector('add-to-cart-component button, .add-to-cart-button, button[type="submit"][name="add"]') ||
      form.querySelector('.diminova-purchase__buy');

    buyBtn?.classList.remove('diminova-atc-flash');
    void buyBtn?.offsetWidth;
    buyBtn?.classList.add('diminova-atc-flash');

    flyToHeaderCart(buyBtn);

    // Optimistic: if bubble already shows items, keep count for temptation gate
    const bubbleNow = Number(
      document.querySelector('.header-actions__cart-icon .cart-bubble__text-count')?.textContent || 0
    );
    if (bubbleNow > 0) S.lastSyncedCount = bubbleNow;
    // At minimum assume 1 after a successful click intent
    if ((S.lastSyncedCount ?? 0) < 1) S.lastSyncedCount = 1;

    const before = S.lastSyncedCount;
    let tries = 0;

    const poll = async () => {
      tries += 1;
      const count = await fetchCartCount();
      if (count != null && (before == null || count !== before || tries >= 8)) {
        setHeaderCartCount(count, { animate: true });
        S.celebrating = false;
        if (count > 0) scheduleCartTemptation();
        return;
      }
      if (tries < 10) {
        setTimeout(poll, 180);
      } else {
        S.celebrating = false;
        scheduleCartTemptation();
      }
    };

    setTimeout(poll, 350);
  }

  function bindForm(form) {
    if (!form) return;
    form.dataset.diminovaQtyBound = 'true';
    form.classList.add('diminova-qty-cart-mode');
    document.body.classList.add('diminova-product-page');
    ensurePurchaseLayout(form);

    fetchCartCount().then((count) => {
      if (count != null) setHeaderCartCount(count, { animate: false });
    });
  }

  function watchDrawerClose() {
    const drawer = document.querySelector('cart-drawer-component, cart-drawer, .cart-drawer');
    if (!drawer || drawer.dataset.diminovaTemptWatch === 'true') return;
    drawer.dataset.diminovaTemptWatch = 'true';
    const mo = new MutationObserver(() => setTimeout(onDrawerMaybeClosed, 200));
    mo.observe(drawer, { attributes: true, attributeFilter: ['open', 'aria-hidden', 'class'] });
  }

  function boot() {
    const form = getProductForm();
    if (form) bindForm(form);
    watchDrawerClose();
  }

  // Keep latest handlers on window so a one-time document bind always calls fresh code
  window.__diminovaCartTemptHandlers = {
    celebrateAddToCart,
    setHeaderCartCount,
    onDrawerMaybeClosed,
    scheduleCartTemptation,
    playCartTemptation,
    stopCartTemptation,
    isGoingToCheckout,
    getProductForm,
  };

  if (!window.__diminovaCartTemptBound) {
    window.__diminovaCartTemptBound = true;

    document.addEventListener(
      'click',
      (event) => {
        const H = window.__diminovaCartTemptHandlers;
        if (!H) return;

        // Stop nudge when client heads to checkout
        if (H.isGoingToCheckout(event.target)) {
          H.stopCartTemptation();
        }

        const buy = event.target.closest(
          '.product-details .add-to-cart-button, .product-details button[type="submit"][name="add"], product-form-component .add-to-cart-button, product-form-component button[type="submit"][name="add"]'
        );
        if (!buy || buy.disabled) return;
        const form = buy.closest('product-form-component') || H.getProductForm();
        if (!form) return;
        H.celebrateAddToCart(form);
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        const H = window.__diminovaCartTemptHandlers;
        if (!H) return;
        const formEl = event.target;
        if (!(formEl instanceof HTMLFormElement)) return;

        if (
          /checkout/i.test(formEl.getAttribute('action') || '') ||
          formEl.querySelector('[name="checkout"]')
        ) {
          H.stopCartTemptation();
        }

        const host = formEl.closest('product-form-component') || H.getProductForm();
        if (!host || !host.contains(formEl)) return;
        if (!formEl.querySelector('[name="add"], .add-to-cart-button')) return;
        H.celebrateAddToCart(host);
      },
      true
    );

    document.addEventListener('cart:updated', (event) => {
      const H = window.__diminovaCartTemptHandlers;
      if (!H) return;
      const count = event.detail?.itemCount ?? event.detail?.cart?.item_count;
      if (typeof count === 'number') {
        H.setHeaderCartCount(count, { animate: true });
        S.celebrating = false;
        if (count <= 0) H.stopCartTemptation();
      }
    });

    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape') {
          setTimeout(() => window.__diminovaCartTemptHandlers?.onDrawerMaybeClosed?.(), 200);
        }
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        const close = event.target.closest(
          '[data-close], .cart-drawer__close, button[aria-label*="Cerrar" i], button[aria-label*="Close" i]'
        );
        if (close) {
          setTimeout(() => window.__diminovaCartTemptHandlers?.onDrawerMaybeClosed?.(), 250);
        }
      },
      true
    );

    // Also stop if navigation starts toward checkout
    window.addEventListener('pagehide', () => {
      if (/\/checkouts?\b/i.test(location.pathname + location.href)) {
        window.__diminovaCartTemptHandlers?.stopCartTemptation?.();
      }
    });
  }

  window.__diminovaCartTempt = {
    play: () => window.__diminovaCartTemptHandlers.playCartTemptation(),
    schedule: () => window.__diminovaCartTemptHandlers.scheduleCartTemptation(),
    stop: () => window.__diminovaCartTemptHandlers.stopCartTemptation(),
    pending: () => ({
      temptPending: S.temptPending,
      temptReadyAt: S.temptReadyAt,
      temptPlaying: S.temptPlaying,
      lastSyncedCount: S.lastSyncedCount,
    }),
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
